import React, { useEffect, useState } from "react";

interface Props {
    price: number;
    currency: string;
}

const PriceComponent: React.FC<Props> = ({ price, currency }) => {
    const numberFormat = (price:number) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: currency
    }).format(price);

    return (
        <>{numberFormat(price)}</>
    );
};

export default PriceComponent;
